import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import GUI from 'lil-gui'
import options from "./js/options.js";
import light from "./js/light.js";
import baseFloor from "./js/base-floor.js";
import loadingManager from "./js/loader.js";
import {pdfCreate} from "./js/pdf.js";
import {ARButton} from "three/addons";
import theme from "./js/theme.js";
import {initAIImageGenerator} from "./js/ai.js";


// const gui = new GUI()

const canvasContainer = document.querySelector('#canvas-container');

const canvasContainerSize = canvasContainer.getBoundingClientRect()

const canvas = document.querySelector('canvas.webgl')

const scene = new THREE.Scene()



const gltfLoader = new GLTFLoader(loadingManager)

const sizes = {
    width: canvasContainerSize.width,
    height: canvasContainerSize.height
}


light(scene)
baseFloor(THREE, scene)
theme(scene)


const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(2, 2, 2)
scene.add(camera)

const controls = new OrbitControls(camera, canvas)
controls.target.set(0, 0.75, 0)
controls.enableDamping = true
controls.enablePan = false

controls.minDistance = 1
controls.maxDistance = 1.5
controls.maxPolarAngle = Math.PI / 2


let model = null

let originalMaterial = null
let pillowMaterial = null



window.addEventListener('resize', () =>
{
    sizes.width = canvasContainer.clientWidth
    sizes.height = canvasContainer.clientHeight

    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 3))
})



const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
    preserveDrawingBuffer: true,
    alpha: true
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setClearColor('#ffffff')
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.toneMapping = THREE.ACESFilmicToneMapping;



const toneMappingParams = {
    exposure: 1.92
}

renderer.toneMappingExposure = toneMappingParams.exposure

// gui.add(toneMappingParams, 'exposure', 0, 3, 0.01)
//     .name('Насыщенность сцены')
//     .onChange((value) => {
//         renderer.toneMappingExposure = value
//     })


const clock = new THREE.Clock()
let previousTime = 0
let autoRotate = true

controls.addEventListener('start', () => {
    autoRotate = false
})


gltfLoader.load(
    './models/modern_arm_chair_01_2k/modern_arm_chair_01_2k.gltf',
    async (gltf) =>
    {
        model = gltf.scene

        model.traverse( (child) => {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;

                if (child.material.name === 'modern_arm_chair_01_pillow') {
                    pillowMaterial = child.material;
                    child.material.roughness = 1.5
                    child.material.needsUpdate = true

                    const pillowSettings = {
                        roughness: pillowMaterial.roughness,
                        brightness: 5,
                    };

                    // const pillowFolder = gui.addFolder('Pillow Material');


                    // pillowFolder.add(pillowSettings, 'roughness', 0, 3, 0.01).onChange((v) => {
                    //     pillowMaterial.roughness = v;
                    // });
                    //
                    // pillowFolder
                    //     .add(pillowSettings, 'brightness', 0, 50, 0.1)
                    //     .name('Color Intensity')
                    //     .onChange(() => {
                    //         applyPillowColor();
                    //     });

                    // const leatherRadios = document.querySelectorAll('input[name="leather"]')
                    //
                    //
                    // function applyPillowColor() {
                    //     let currentColor
                    //
                    //     leatherRadios.forEach((item)=>{
                    //         if (item.checked){
                    //             item.value === 'default' ? currentColor = '#FFFFFF' : currentColor = item.value
                    //         }
                    //     })
                    //
                    //     pillowMaterial.color.set(currentColor)
                    //
                    //     pillowMaterial.color
                    //         .multiplyScalar(pillowSettings.brightness);
                    //
                    //     pillowMaterial.needsUpdate = true;
                    // }

                }

                if (child.material.name === 'modern_arm_chair_01_legs') {
                    originalMaterial = child.material;
                    child.material.roughness = 0.5
                    child.material.needsUpdate = true
                }
            }
        });

        gltf.scene.position.y = 0.3

        scene.add(model)

        options(model, originalMaterial, scene, camera)
        await pdfCreate(renderer, camera, scene, model)

        initAIImageGenerator({
            renderer,
            camera,
            scene,
        });

    }
)

renderer.xr.enabled = true;

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

if (isIOS) {
    const iosButton = document.createElement('button');
    iosButton.id = 'ARButtonIOS';


    iosButton.onclick = () => {
        const anchor = document.createElement('a');
        anchor.setAttribute('rel', 'ar');
        anchor.appendChild(document.createElement('img'));

        anchor.setAttribute('href', './models/modern_arm_chair_01_2k.usdz');

        anchor.click();
    };

    canvasContainer.appendChild(iosButton);

} else {
    const webXRButton = ARButton.createButton(renderer, {
        requiredFeatures: ['hit-test']
    });
    canvasContainer.appendChild(webXRButton);
}


const reticle = new THREE.Mesh(
    new THREE.RingGeometry(0.1, 0.12, 32).rotateX(-Math.PI / 2),
    new THREE.MeshBasicMaterial({ color: 0x00ff00 })
);
reticle.matrixAutoUpdate = false;
reticle.visible = false;
scene.add(reticle);

let hitTestSource = null;
let hitTestSourceRequested = false;

renderer.setAnimationLoop((time, frame) => {
    if (frame) {
        const session = renderer.xr.getSession();

        if (hitTestSourceRequested === false) {
            session.requestReferenceSpace('viewer').then((referenceSpace) => {
                session.requestHitTestSource({ space: referenceSpace }).then((source) => {
                    hitTestSource = source;
                });
            });
            hitTestSourceRequested = true;
        }

        if (hitTestSource) {
            const hitTestResults = frame.getHitTestResults(hitTestSource);
            if (hitTestResults.length) {
                const hit = hitTestResults[0];
                const referenceSpace = renderer.xr.getReferenceSpace();
                const pose = hit.getPose(referenceSpace);

                reticle.visible = true;
                reticle.matrix.fromArray(pose.transform.matrix);
                if (model) {
                    model.visible = true;

                    model.position.setFromMatrixPosition(reticle.matrix);
                    model.position.y = -1;
                    const lookAtTarget = new THREE.Vector3(camera.position.x, model.position.y, camera.position.z);
                    model.lookAt(lookAtTarget);
                }
            } else {
                reticle.visible = false;
            }
        }
    }

    renderer.render(scene, camera);
});

renderer.xr.addEventListener('sessionstart', () => {
    autoRotate = false
    controls.enabled = false;

    model.position.z = -3;
    model.position.y = -1;
});

renderer.xr.addEventListener('sessionend', () => {
    if (model) {
        model.position.set(0, 0.3, 0);
        model.rotation.set(0, 0, 0);
        model.scale.set(1, 1, 1);
        model.visible = true;
    }

    controls.enabled = true;

    camera.position.set(2, 2, 2);
    controls.update();

    if (reticle) reticle.visible = false;

    hitTestSourceRequested = false;
    hitTestSource = null;

    autoRotate = true
});

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    if (model && autoRotate) {
        model.rotation.y += deltaTime * 0.3
    }

    controls.update()

    renderer.render(scene, camera)

    window.requestAnimationFrame(tick)
}

tick()